module.exports = __webpack_public_path__ + "static/media/kbb.062e4fd7.png";